<div class="py-2 px-0">
  <div class="incident-search-wrapper">
    <div>
      <span style="font-weight: 600; font-size: 1.1rem; color: #fff; flex: 1;">
        Campus <small>({{ campusCount }})</small>
      </span>
    </div>

    <div class="d-flex mb-1 gap-2 " style="margin-top: 8px; position: relative;">
      <input class="listSearch form-control" type="text" id="searchinput" [(ngModel)]="query" (input)="onSearch()"
        placeholder="Search Campus" autofocus />
      <i class="fa fa-search search-icon-wrapper"></i>
    </div>
  </div>

  <!-- Campus Roles Drilldown Tree -->
  <div class="custom-scroll v2" id="campus-list-scroll">
    <ul class="tree">
      @for (node of filteredCampusRoles; track node.id) {
        <ng-container *ngTemplateOutlet="treeTemplate; context: { $implicit: node }"></ng-container>
      }
    </ul>
  </div>

  <ng-template #treeTemplate let-node>
    @if (isLeafBuilding(node)) {
      <!-- Building Leaf Item -->
      <li (click)="goToBuilding(node.item)" class="building-tree-item" style="cursor: pointer; border-bottom: 1px solid #444; padding: 5px 4px;">
        <div class="row m-0">
          <div class="col-lg-8 p-0 text-truncate" [title]="node.name">
            {{ node.name }}
          </div>
          <div class="col-lg-4 d-flex justify-content-end p-0">
            <i class="fa-solid fa-circle-info p-1"
              (click)="getCampusInfo($event, node.item); $event.stopPropagation()"
              style="cursor: pointer" title="view info"></i>
            <i class="fa fa-envelope p-1"
              (click)="messagePOC($event, node.item); $event.stopPropagation()"
              style="cursor: pointer" aria-hidden="true" title="send message"></i>
          </div>
        </div>
        @if (containsBasePerimeter(node.item) && !orgIsGG()) {
          <div class="row m-0">
            <div class="col-lg-12 p-0">
              <div class="incident-actions" style="border:none">
                @for (cat of (incidentCategoryList[node.item?.organizationId || node.organizationId] | slice:0:4); track cat.id) {
                  <button
                    type="button"
                    class="btn btnInciden panic-button-tiny panic-button-tiny-icon"
                    (click)="panicButtonPressed($event, node.item, cat, false); $event.stopPropagation()"
                    style="padding: 0px"
                    >
                    <img
                      [src]="'assets/img/glyphicons/glyphicons-' + cat.iconCode + '.png'"
                      [title]="cat.label"
                      class="icon_border"
                      />
                  </button>
                }
                <button
                  type="button"
                  class="btn btnInciden panic-button-tiny panic-button-tiny-icon"
                  (click)="panicButtonPressed($event, node.item, null, false); $event.stopPropagation()"
                  style="padding: 0px"
                  >
                  <i class="fa fa-pencil fa-1x text-white icon_i" title="Other Emergency"></i>
                </button>
              </div>
            </div>
          </div>
        }
      </li>
    } @else {
      <!-- Grouping / Branch Node (AREA, CAMPUS, etc.) -->
      <li>
        <div class="node-item">
          @if (node.children?.length) {
            <span
              (click)="toggle(node); $event.stopPropagation()"
              class="toggle"
              >
              <i
                class="fa"
                [ngClass]="node.expanded ? 'fa-caret-down fa-1x' : 'fa-caret-right fa-1x'">
              </i>
            </span>
          } @else {
            <span class="toggle" style="opacity: 0.3;">•</span>
          }
          <span 
            class="node-label" 
            [title]="node.name"
            [style.cursor]="node.level?.toUpperCase() === 'CAMPUS' ? 'pointer' : 'default'"
            (click)="node.level?.toUpperCase() === 'CAMPUS' ? onCampusClick(node) : toggle(node)">
            {{ node.name }}
          </span>
        </div>
        @if (node.children?.length && node.expanded) {
          <ul class="p-1">
            @for (child of node.children; track child.id) {
              <ng-container
                *ngTemplateOutlet="treeTemplate; context: { $implicit: child }">
              </ng-container>
            }
          </ul>
        }
      </li>
    }
  </ng-template>
</div>
